import React, { useEffect, useState } from "react"
import { X } from "lucide-react"
import "./AddTaxInfoModal.scoped.scss"
import { notification, Select } from "antd"
import axios from "axios"
import { apiClient } from "../../../api"
import { token } from "../../../config"
import { provinceList } from "../../../mockData/province"

const taxTypes = [
  { id: 1, name: "Individual" },
  { id: 2, name: "Corporate" },
]

const AddTaxInfoModal = ({ isOpen, onClose, taxInfoList, taxInfoId, getTaxInfo }) => {
  const [formData, setFormData] = useState({
    type: 1,
    contactName: "",
    branch: "",
    mobile: "",
    idCard: "",
    address: "",
    province: "",
    district: "",
    subdistrict: "",
    postalCode: "",
    setDefault: false,
  })
  const [rawData, setRawData] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [subdistrictOptions, setSubdistrictOptions] = useState([]);
  const [errors, setErrors] = useState({});

  const handleSaveTaxInfo = async () => {
    const req = {
      "taxvoice_id": taxInfoId ? taxInfoId.toString() : "",
      "type": formData.type ? formData.type : 1,
      "name": formData.contactName,
      "mobile": formData.mobile,
      "idcard": formData.idCard,
      "address": formData.address,
      "branch": formData.branch,
      "province": formData.province,
      "district": formData.district,
      "subdistrict": formData.subdistrict,
      "post": formData.postalCode.toString(),
      "savedefault": formData.setDefault,
      "new_taxvoice": taxInfoId ? false : true,
      "requestTax": 0,
    }

    await apiClient.post("api/ecom/saveTaxInfo", req, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        if (response.data.status == 200) {
          notification.success({
            message: 'Success',
            description: 'Successfully save tax info information',
            className: 'custom-notification',
            duration: 5
          })
        } else {
          notification.error({
            message: 'Error',
            description: response.data.message,
            className: 'custom-notification',
            duration: 5
          })
        }
        getTaxInfo()
        onClose()
      })
      .catch((error) => {
        notification.error({
          message: 'Error',
          description: 'Error save tax info information',
          className: 'custom-notification',
          duration: 5
        })
      })
  }

  const validateField = (field, value) => {
    switch (field) {
      case "mobile":
        if (!/^0\d{9}$/.test(value)) {
          return "Phone must start with 0 and be 10 digits";
        }
        break;
      case "idCard":
        if (!/^\d{13}$/.test(value)) {
          return "ID Card must be 13 digits";
        }
        break;
      default:
        return "";
    }
    return "";
  };

  const handleInputChange = (field, value) => {
    let newValue = value;

    if (field === "mobile") {
      newValue = newValue.replace(/\D/g, "").slice(0, 10);
    }

    if (field === "idCard") {
      newValue = newValue.replace(/\D/g, "").slice(0, 13);
    }

    if (field === "province") {
      setFormData((prev) => ({
        ...prev,
        subdistrict: "",
        district: "",
        postalCode: "",
      }));
    }

    if (field === "district") {
      setFormData((prev) => ({
        ...prev,
        subdistrict: "",
        postalCode: "",
      }));
    }

    // validate
    const errorMessage = validateField(field, newValue);

    setFormData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: errorMessage,
    }));
  };


  const handleSave = () => {
    handleSaveTaxInfo()
    onClose()
  }

  const getProvince = async () => {
    setRawData(provinceList)
  }

  useEffect(() => {
    getProvince()
  }, [])
 
  useEffect(() => {
    if (taxInfoId) {
      setFormData({
        type: taxInfoList.find(row => row.id === taxInfoId).type,
        contactName: taxInfoList.find(row => row.id === taxInfoId).name,
        mobile: taxInfoList.find(row => row.id === taxInfoId).mobile,
        idCard: taxInfoList.find(row => row.id === taxInfoId).id_card,
        address: taxInfoList.find(row => row.id === taxInfoId).address,
        branch: taxInfoList.find(row => row.id === taxInfoId).branch,
        province: taxInfoList.find(row => row.id === taxInfoId).province,
        district: taxInfoList.find(row => row.id === taxInfoId).district,
        subdistrict: taxInfoList.find(row => row.id === taxInfoId).subdistrict,
        postalCode: taxInfoList.find(row => row.id === taxInfoId).post,
        setDefault: taxInfoList.find(row => row.id === taxInfoId).isDefault
      })
    } else {
      setFormData({
        type: 1,
        contactName: "",
        branch: "",
        mobile: "",
        idCard: "",
        address: "",
        province: "",
        district: "",
        subdistrict: "",
        postalCode: "",
        setDefault: false,
      })
    }
  }, [taxInfoId])

  if (!isOpen) return null

  const isValidForm = () => {
    const phoneValid = /^0\d{9}$/.test(formData.mobile);   // 10 digits, starts with 0
    const idCardValid = /^\d{13}$/.test(formData.idCard); // exactly 13 digits
    const nameValid = formData.contactName;
    const addressValid = formData.address;
    const provinceValid = formData.province;
    const districtValid = formData.district;
    const subdistrictValid = formData.subdistrict;
    const postalCodeValid = formData.postalCode;

    return phoneValid && idCardValid && nameValid && addressValid && provinceValid && districtValid && subdistrictValid && postalCodeValid;
  };

  const handleCancel = () => {
    onClose()
    setErrors({})
    setFormData({
      type: 1,
      contactName: "",
      branch: "",
      mobile: "",
      idCard: "",
      address: "",
      province: "",
      district: "",
      subdistrict: "",
      postalCode: "",
      setDefault: false,
    })
  }

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className='modal-container-wrapper'>
          <div className="modal-header">
            <h2>Tax invoice information</h2>
            <div className="close-button-wrapper" onClick={onClose}>
              <button className="close-button">
                <X size={20} />
              </button>
            </div>
          </div>

          <div className="tax-info-modal-content">
            <div className="radio-group">
              {taxTypes.map((type) => (
                <label key={type.id} className="radio-option">
                  <input
                    type="radio"
                    name="type"
                    value={type.id}
                    checked={formData.type === type.id}
                    onChange={(e) => handleInputChange("type", parseInt(e.target.value))}
                  />
                  <span className="radio-label">{type.name}</span>
                </label>
              ))}
            </div>

            <div className="tax-info-form-group">
              <label className="form-label">
                Contact name <span className="required">*</span>
              </label>
              <input
                type="text"
                className="tax-info-form-input"
                placeholder="Contact Name"
                value={formData.contactName}
                onChange={(e) => handleInputChange("contactName", e.target.value)}
              />
            </div>

            <div className="tax-info-form-row">
              {formData.type === 2 && (
                <div className="tax-info-form-group">
                  <label className="form-label">
                    Branch <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Branch"
                    className="tax-info-form-input"
                    value={formData.branch}
                    onChange={(e) => handleInputChange("branch", e.target.value)}
                  />
                </div>
              )}

              <div className="tax-info-form-group">
                <label className="form-label">
                  Phone <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="tax-info-form-input"
                  placeholder="Phone"
                  value={formData.mobile}
                  onChange={(e) => handleInputChange("mobile", e.target.value)}
                />
                {errors.mobile && <span className="error-text">{errors.mobile}</span>}
              </div>
              <div className="tax-info-form-group">
                <label className="form-label">
                  ID Card/ Tax ID number <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="tax-info-form-input"
                  placeholder="ID Card/ Tax ID Number"
                  value={formData.idCard}
                  onChange={(e) => handleInputChange("idCard", e.target.value)}
                />
                {errors.idCard && <span className="error-text">{errors.idCard}</span>}
              </div>

              <div className="tax-info-form-group">
                <label className="form-label">
                  Address <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="tax-info-form-input"
                  placeholder="Address"
                  value={formData.address}
                  onChange={(e) => handleInputChange("address", e.target.value)}
                />
              </div>
              <div className="tax-info-form-group">
                <label className="form-label">
                  Province <span className="required">*</span>
                </label>
                <Select
                  showSearch
                  placeholder="Province"
                  value={formData.province || undefined}
                  onChange={(prov) => {
                    handleInputChange("province", prov);
                    const province = rawData?.find(p => p.name_th === prov);
                    setDistrictOptions(province?.districts.map(a => a.name_th) || []);
                  }}
                >
                  {rawData?.map(p => <Select.Option key={p.id} value={p.name_th}>{p.name_th}</Select.Option>)}
                </Select>
              </div>

              <div className="tax-info-form-group">
                <label className="form-label">
                  District <span className="required">*</span>
                </label>
                <Select
                  showSearch
                  placeholder="District"
                  value={formData.district || undefined}
                  disabled={!formData.province}
                  onChange={(amp) => {
                    handleInputChange("district", amp);
                    const province = rawData.find(p => p.name_th === formData.province);
                    const amph = province?.districts.find(a => a.name_th === amp);
                    setSubdistrictOptions(amph?.sub_districts.map(d => d.name_th) || []);
                  }}
                >
                  {districtOptions.map(d => <Select.Option key={d} value={d}>{d}</Select.Option>)}
                </Select>
              </div>
              <div className="tax-info-form-group">
                <label className="form-label">
                  Subdistrict <span className="required">*</span>
                </label>
                <Select
                  showSearch
                  placeholder="Subdistrict"
                  value={formData.subdistrict || undefined}
                  disabled={!formData.district}
                  onChange={(td) => {
                    handleInputChange("subdistrict", td);
                    const province = rawData.find(p => p.name_th === formData.province);
                    const districts = province?.districts.find(a => a.name_th === formData.district);
                    const tamb = districts?.sub_districts.find(d => d.name_th === td);
                    if (tamb) {
                      handleInputChange("postalCode", tamb.zip_code);
                    }
                  }}
                >
                  {subdistrictOptions.map(s => <Select.Option key={s} value={s}>{s}</Select.Option>)}
                </Select>
              </div>
              <div className="tax-info-form-group">
                <label className="form-label">
                  Postal code <span className="required">*</span>
                </label>
                <input
                  disabled={true}
                  type="text"
                  className="tax-info-form-input postal-code"
                  placeholder="Postal Code"
                  value={formData.postalCode}
                  onChange={(e) => handleInputChange("postalCode", e.target.value)}
                />
              </div>
            </div>

            <div className="checkbox-group">
              <div className="tax-info-checkbox-option">
                <input
                  type="checkbox"
                  checked={formData.setDefault}
                  onChange={(e) => handleInputChange("setDefault", e.target.checked)}
                />
                <span className="checkbox-label">Set Default</span>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn-cancel" onClick={() => handleCancel()}>
                Cancel
              </button>
              <button
                className="btn-save"
                disabled={!isValidForm()}
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddTaxInfoModal